import React, { useState, useEffect } from 'react';
import './terapi.css';
import SecondaryButton from '../../components/secondaryButton';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../../firebase';

// Funktion til at håndtere både markdown og HTML-indhold
const prepareContent = (content) => {
  if (!content) return '';

  // Hvis teksten allerede er HTML (fra rich text editor)
  if (content.includes('<p>') || content.includes('<h') || content.includes('<ul>')) {
    // Vi beholder HTML som den er, da formatering håndteres korrekt i rich text editor
    return content;
  }

  // Hvis det er markdown eller plain text
  // Konverter overskrifter
  let html = content.replace(/^## (.*?)$/gm, '<h3>$1</h3>');

  // Konverter fed tekst
  html = html.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
  html = html.replace(/\*(.*?)\*/g, '<strong>$1</strong>');

  // Konverter bullet points
  html = html.replace(/^- (.*?)$/gm, '<li>$1</li>');
  
  // Del teksten på dobbelte linjeskift, hvilket normalt indikerer nye afsnit
  const paragraphs = html.split(/\n\s*\n/); // Split ved tomme linjer
  html = paragraphs.map(p => {
    const trimmedP = p.trim();
    if (trimmedP === '') return '';
    
    // Håndter lister
    if (trimmedP.includes('<li>')) {
      return `<ul>${trimmedP}</ul>`;
    }
    
    // Håndter overskrifter
    if (trimmedP.includes('<h3>')) {
      return trimmedP;
    }
    
    // Almindelige afsnit - bevar enkelte linjeskift som mellemrum
    // men vi erstatter ikke \n med <br> for at undgå uønskede linjeskift
    return `<p>${trimmedP.replace(/\n/g, ' ')}</p>`;
  }).join('\n\n'); // Tilføj afstand mellem afsnit

  return html;
};

const Terapi = () => {
  const [terapiData, setTerapiData] = useState({
    title: '',
    heroImage: '',
    textBefore: '',
    textAfter: '',
    sections: []
  });
  
  const [terapiOmrader, setTerapiOmrader] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchTerapiData = async () => {
      try {
        // Fetch terapi main content
        const terapiDocRef = doc(db, 'content', 'terapi');
        const terapiDoc = await getDoc(terapiDocRef);
        
        if (terapiDoc.exists()) {
          setTerapiData(terapiDoc.data());
        }
        
        // Fetch terapi områder
        const terapiOmraderDocRef = doc(db, 'content', 'terapiOmrader');
        const terapiOmraderDoc = await getDoc(terapiOmraderDocRef);
        
        if (terapiOmraderDoc.exists() && terapiOmraderDoc.data().omrader) {
          setTerapiOmrader(terapiOmraderDoc.data().omrader);
        }
      } catch (error) {
        console.error('Fejl ved hentning af terapi data:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchTerapiData();
  }, []);

  if (isLoading) {
    return <div className="terapi-loading">Indlæser...</div>;
  }

  return (
    <div className="terapi-side">
      <div className="terapi-container">
        <h1>{terapiData.title}</h1>
        
        <div className="terapi-hero">
          <div className="terapi-hero-content">
            <div className="terapi-hero-billed">
              <img src={terapiData.heroImage} alt="Terapi hero" />
            </div>
            <div 
              className="terapi-hero-text"
              dangerouslySetInnerHTML={{ __html: prepareContent(terapiData.textBefore) }}
            />
          </div>
        </div>

        {terapiData.sections && terapiData.sections.map((section, index) => (
          <div key={index} className="terapi-section">
            <h3>{section.title}</h3>
            <div dangerouslySetInnerHTML={{ __html: prepareContent(section.content) }} />
          </div>
        ))}
        
        <div className="terapi-områder">
          {terapiOmrader.map((omrade, index) => (
            <div key={omrade.id} className="terapi-kort">
              <div className="terapi-venstre">
                <img src={omrade.imageUrl} alt={omrade.title} />
              </div>
              <div className="terapi-højre">
                <h2>{omrade.title}</h2>
                <p>{omrade.description}</p>
                <SecondaryButton href={omrade.link}>Læs mere</SecondaryButton>
              </div>
            </div>
          ))}
        </div>
        
        {terapiData.textAfter && (
          <div className="terapi-bottom">
            <div 
              className="terapi-bottom-content"
              dangerouslySetInnerHTML={{ __html: prepareContent(terapiData.textAfter) }}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default Terapi;
